<template>
    <main class="main services">
        <div class="container">
            <bread-crumbs
                text="Wróć do listy wszystkich usług"
                default-url="services"
            />
        </div>

        <page-preloader v-if="serviceStatus === 'loading'"/>
        <div v-else-if="service" class="v-service__wrapper container">
            <div class="row">
                <div class="col-lg-3">
                    <img
                        v-if="
                            service.graphics && service.graphics.bigIconMinioUrl
                        "
                        :src="service.graphics.bigIconMinioUrl"
                        width="390"
                        height="297"
                        alt
                        class="img-fluid"
                    />
                </div>
                <div class="col-lg-8 offset-lg-1">
                    <div class="v-service__header">
                        <h1 class="h2">{{ service.name }}</h1>
                        <div class="v-service__buttons my-2">
                            <button
                                :class="{
                                    disabled:
                                        !isSubscriptionsToActivate &&
                                        !hideDataFromLotteryUser
                                }"
                                type="button"
                                class="btn btn-secondary"
                                @click="
                                    activateService(
                                        !isLocationLevelService,
                                        isLocationLevelService
                                    )
                                "
                            >
                                Włącz usługę
                            </button>
                        </div>
                    </div>

                    <div
                        class="v-service__text"
                        v-html="service.description_long"
                    />

                    <section
                        id="dokumenty"
                        class="v-service__download"
                        v-if="service.documents && service.documents.length > 0"
                    >
                        <h2 class="v-service__subtitle">Dokumenty:</h2>
                        <p v-if="hideDataFromLotteryUser">
                            Tutaj wyświetlane są dokumenty powiązane z usługą
                        </p>
                        <ul v-else class="v-service__documentList pl-3">
                            <li
                                v-for="(file, idx) in service.documents"
                                :key="idx"
                            >
                                <a
                                    class="v-service__link"
                                    target="_blank"
                                    :href="file.minioUrl"
                                >
                                    <a-icon
                                        style="width: 20px; height: 20px"
                                        icon="Download"
                                    />
                                    <span>{{ file.name }}</span>
                                </a>
                            </li>
                        </ul>
                    </section>

                    <section
                        id="consents"
                        class="v-service__consents"
                        v-if="marketingConsentsECSP"
                    >
                        <consent-list
                            :title="consentDetails.title"
                            consent-code="ECSP"
                            :consent-details="consentDetails.consentDetails"
                            :data="marketingConsentsECSP"
                            class="mb-3"
                        />
                    </section>

                    <section id="status" class="v-service__shops">
                        <template v-if="isLocationLevelService">
                            <h2 class="v-service__subtitle">
                                Status usługi w sklepach
                            </h2>
                            <p
                                v-if="!hideDataFromLotteryUser"
                                class="v-service__status"
                            >
                                Aktywnych
                                <strong>
                                    {{ service.number_of_entities_with_subscription }}
                                    z
                                    {{ availableSubscriptions.length }}
                                </strong>
                                sklepów:
                            </p>

                            <div
                                v-if="!hideDataFromLotteryUser"
                                class="
                                    form-group
                                    input-with-icon
                                    promo-details-search
                                "
                            >
                                <search-input
                                    name="Search"
                                    :search-params-tooltip="['nazwie sklepu', 'adresie']"
                                    :search-input="searchInput"
                                    @change="searchInput = $event"
                                />
                            </div>

                            <div class="v-service__shoplist t-shops">
                                <service-shop
                                    v-for="(shop, idx) in subscriptions"
                                    :key="idx"
                                    :shop="shop"
                                />
                            </div>
                        </template>

                        <div class="v-service__actions d-flex flex-wrap gap-1">
                            <button
                                v-if="isLocationLevelService"
                                :disabled="
                                    !isSubscriptionsToActivate &&
                                        !hideDataFromLotteryUser
                                "
                                type="button"
                                class="btn btn btn-secondary"
                                @click="
                                    activateService(
                                        false,
                                        !isCheckedSubscriptionsToActivate
                                    )
                                "
                            >
                                Włącz usługę
                            </button>
                            <button
                                v-else
                                :disabled="
                                    !isSubscriptionsToActivate &&
                                        !hideDataFromLotteryUser
                                "
                                type="button"
                                class="btn btn-secondary"
                                @click="activateService(true, false)"
                            >
                                Włącz usługę
                            </button>
                        </div>
                    </section>

                    <div
                        class="v-service__cancel"
                        v-if="!hideDataFromLotteryUser"
                    >
                        <h2 class="v-service__subtitle">Inne ustawienia</h2>

                        <div>
                            <button
                                :disabled="
                                    service.number_of_entities_with_subscription ==
                                        0
                                "
                                type="button"
                                class="btn btn-custom-danger"
                                data-toggle="modal"
                                data-target="#modal-services-cancel"
                                @click="cancelService"
                            >
                                <span>Wyłącz usługę</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import ServiceShop from '@/components/services/ServiceShop'
import ConsentList from '@/components/settings/ConsentList'

export default {
    data() {
        return {
            searchInput: ''
        }
    },
    components: {
        ServiceShop,
        ConsentList
    },
    watch: {
        service(val) {
            if (val === null || val.errors) {
                this.$router.push({ name: 'services' })
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content:
                        'Użytkownik nie znajduje się na liście odbiorców wybranej usługi.'
                })
            }
        }
    },
    computed: {
        hideDataFromLotteryUser() {
            return this.isLotteryUser && this.service.code !== 'mp_pp'
        },
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },
        service() {
            return this.$store.getters.getService
        },
        subscriptions() {
            let subscriptions
            if (this.isLotteryUser) {
                subscriptions = [
                    {
                        entityData: {
                            id: 1,
                            name: 'Sklep 1',
                            address: 'ul. Rzeczna 1'
                        },
                        id: 1,
                        status: 'active'
                    },
                    {
                        entityData: {
                            id: 2,
                            name: 'Sklep 2',
                            address: 'ul. Rzeczna 2'
                        },
                        id: 2,
                        status: 'active'
                    }
                ]
            } else {
                subscriptions = this.service.subscriptions.filter(
                    el => el.status !== 'not_allowed'
                )
                if (subscriptions) {
                    subscriptions = subscriptions.filter(item => {
                        const searchLower = this.searchInput.toLowerCase()
                        return item.entityData.name.toLowerCase().includes(searchLower) ||
                            item.entityData.address.toLowerCase().includes(searchLower)
                    })
                }
            }

            return subscriptions
        },
        serviceStatus() {
            return this.$store.getters.getServiceStatus
        },
        isSubscriptionsToActivate() {
            return this.service.subscriptions.some(
                el => el.status === 'inactive'
            )
        },
        isCheckedSubscriptionsToActivate() {
            return this.service.subscriptions.some(
                el => el.status === 'inactive' && el.checked
            )
        },
        availableSubscriptions() {
            return this.service.subscriptions.filter(
                el => el.status !== 'not_allowed'
            )
        },
        isLocationLevelService() {
            return this.service.level === 'Location'
        },
        marketingConsentsECSP() {
            return (
                !this.$store.getters.isShopUser &&
                this.service.code === 'pp_ms' &&
                this.$store.getters.getMarketingECSPConsents
            )
        },
        consentDetails() {
            return this.$store.getters.getMarketingDetails('ECSP')
        }
    },
    created() {
        this.$store.dispatch('serviceFetch', this.$route.params.id)
        this.$scrollTo('body', 200, {
            offset: 0
        })
    },
    beforeMount() {
        if (this.marketingConsentsECSP) {
            this.$store.dispatch('consentsFetch')
        }
    },
    methods: {
        activateService(allShops, isCheckedAllInactive) {
            if (this.isLotteryUser && this.service.code !== 'mp_pp') {
                this.$store.dispatch('onLotteryUserNoPermission')
                return
            }
            if ((allShops && this.isSubscriptionsToActivate) || !allShops) {
                this.$store.dispatch('openModal', {
                    component: 'AcceptService',
                    args: {
                        service: this.service,
                        allShops,
                        isCheckedAllInactive,
                        singleService: true
                    }
                })
            }
        },
        async cancelService() {
            if (
                (this.service.code === 'emka' || this.service.code === 'pp_ms') &&
                !this.$store.getters.getServices?.length
            ) {
                await this.$store.dispatch('servicesFetch')
            }
            this.$store.dispatch('openModal', {
                component: 'CancelService',
                args: {
                    service: this.service,
                    allShops: true,
                    singleService: true
                }
            })
        }
    }
}
</script>
